import { getUser as getRawUser } from '@/core/data/gateways/api';
import {
	normalizeUnknownError,
	ObservabilityStrategy,
} from '@/observability/observability';
import { getAuthCookie } from './auth.client';
import { createUser } from './user.factory';
import type { User } from './user.schema';

export async function getUser(): Promise<User | null> {
	const authCookie = await getAuthCookie();

	if (!authCookie?.id) return null;
	if (!authCookie?.token) return null;

	let response = null;

	try {
		response = await getRawUser(authCookie.id, authCookie.token);
	} catch (error) {
		ObservabilityStrategy.recordEvent({
			extras: normalizeUnknownError(error),
			family: 'auth',
			level: 'warning',
			name: 'Could not identify user',
		});
	}

	if (!response) return null;

	return createUser().parseAsync(response);
}
